module.exports = __webpack_public_path__ + "static/trees-3.8-92758901ec7310c4ddb8e2dfa1a6e2ca.png";